export const Print = ({ width = '16', height = '15', color = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      id="a"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5171,35.415H6.4026c-.4985,0-.9026-.4041-.9026-.9026v-13.504c0-.4985,.4041-.9026,.9026-.9026H41.5974c.4985,0,.9026,.4041,.9026,.9026v13.504c0,.4985-.4041,.9026-.9026,.9026h-8.1144"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3px"
      />
      <rect
        x="14.5171"
        y="31.4366"
        width="18.9659"
        height="10.13"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3px"
      />
      <path
        d="M33.4829,20.1056H14.5171V6.4334h14.9659l4,4v9.6723Z"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3px"
      />
      <polyline
        points="29.8724 6.4334 29.8724 10.0439 33.4829 10.0439"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3px"
      />
      <circle cx="33.8187" cy="22.8983" r=".75" fill={color} />
    </svg>
  );
};
